export interface CountryItem {
	code: string;
	name: string;
}

export interface RegionGroup {
	region: string;
	countries: CountryItem[];
}

export const REGION_COUNTRY_CODES: Record<string, string[]> = {
	Africa: [
		'NG',
		'ET',
		'EG',
		'CD',
		'TZ',
		'ZA',
		'KE',
		'UG',
		'DZ',
		'SD',
		'MA',
		'AO',
		'MZ',
		'GH',
		'MG',
		'CM',
		'CI',
		'NE',
		'BF',
		'ML',
		'MW',
		'ZM',
		'SN',
		'TD',
		'SO',
		'ZW',
		'GN',
		'RW',
		'BJ',
		'BI',
		'TN',
		'SS',
		'TG',
		'SL',
		'LY',
		'CG',
		'LR',
		'CF',
		'MR',
		'ER',
		'NA',
		'GM',
		'BW',
		'GA',
		'LS',
		'GW',
		'GQ',
		'MU',
		'SZ',
		'DJ',
		'KM',
		'CV',
		'ST',
		'SC',
		'SH',
	],
	'Central America And Caribbean': [
		'AG',
		'BB',
		'BS',
		'BZ',
		'KY',
		'CR',
		'CU',
		'DM',
		'DO',
		'SV',
		'GD',
		'GT',
		'HT',
		'HN',
		'JM',
		'NI',
		'PA',
		'PR',
		'KN',
		'LC',
		'VC',
		'TT',
		'TC',
		'VG',
		'VI',
		'BQ',
		'SX',
		'CW',
	],
	'Central Asia': ['AF', 'AM', 'AZ', 'GE', 'KZ', 'UZ', 'TM', 'TJ', 'KG'],
	'East Asia': ['CN', 'HK', 'JP', 'KR', 'MO', 'KP', 'MN', 'TW'],
	'East Europe': ['BY', 'RU', 'UA', 'MD'],
	Europe: [
		'GB',
		'DE',
		'FR',
		'IT',
		'ES',
		'PL',
		'RO',
		'NL',
		'BE',
		'GR',
		'CZ',
		'PT',
		'SE',
		'HU',
		'AT',
		'CH',
		'BG',
		'DK',
		'FI',
		'SK',
		'NO',
		'IE',
		'HR',
		'BA',
		'AL',
		'LT',
		'MK',
		'SI',
		'LV',
		'EE',
		'ME',
		'LU',
		'MT',
		'IS',
		'AD',
		'MC',
		'LI',
		'SM',
		'VA',
		'CY',
		'GI',
		'GG',
		'IM',
		'JE',
		'RS',
		'RK',
	],
	'Middle East': [
		'SA',
		'IR',
		'TR',
		'IQ',
		'YE',
		'SY',
		'JO',
		'AE',
		'IL',
		'LB',
		'PS',
		'OM',
		'KW',
		'QA',
		'BH',
	],
	'North America': ['US', 'CA', 'MX', 'GL', 'BM'],
	Oceania: [
		'AU',
		'PG',
		'NZ',
		'FJ',
		'GU',
		'SB',
		'VU',
		'WS',
		'KI',
		'TO',
		'FM',
		'MH',
		'PW',
		'TV',
		'NR',
		'NU',
		'MP',
	],
	'South America': [
		'BR',
		'AR',
		'CO',
		'VE',
		'PE',
		'CL',
		'EC',
		'BO',
		'PY',
		'UY',
		'GY',
		'SR',
	],
	'South Asia': ['IN', 'PK', 'BD', 'NP', 'BT', 'LK', 'MV'],
	'South East Asia': [
		'ID',
		'BN',
		'LA',
		'TH',
		'VN',
		'PH',
		'MY',
		'SG',
		'MM',
		'KH',
		'TL',
	],
};

const codeToRegion: Record<string, string> = {};
for (const [region, codes] of Object.entries(REGION_COUNTRY_CODES)) {
	for (const code of codes) {
		codeToRegion[code] = region;
	}
}

export function getRegionForCountry(code: string): string {
	return codeToRegion[code] || 'Other';
}

export function groupCountriesByRegion(
	countries: { Code: string; Name: string }[]
): RegionGroup[] {
	const regionMap = new Map<string, CountryItem[]>();

	for (const country of countries) {
		const region = getRegionForCountry(country.Code);
		if (!regionMap.has(region)) {
			regionMap.set(region, []);
		}
		regionMap.get(region)!.push({ code: country.Code, name: country.Name });
	}

	for (const countries of regionMap.values()) {
		countries.sort((a, b) => a.name.localeCompare(b.name));
	}

	return Array.from(regionMap.entries())
		.map(([region, countries]) => ({ region, countries }))
		.sort((a, b) => a.region.localeCompare(b.region));
}
